import Account from "./account";
import Address from "./address";
import Survey from "./survey";

export default class Location {
  public idLocation: number = 0;
  public idAccount: number = 0;
  public idAddress: number = 0;
  public locationName: string = "";
  public locationNumber: string = "";
  public siteManagerName: string = "";
  public siteManagerPhone: string = "";
  public siteManagerEmail: string = "";
  public siteInstructions: string = "";
  public locationPhone: string = "";
  public locationType: string = "";
  public leaseType: string = "";
  public account: Account = new Account();
  public address: Address = new Address();
  public surveys: Survey[] = [];
}
